import { render, staticRenderFns } from "./sentenceView.vue?vue&type=template&id=8571b5d4&scoped=true&"
import script from "./sentenceView.vue?vue&type=script&lang=js&"
export * from "./sentenceView.vue?vue&type=script&lang=js&"
import style0 from "./sentenceView.vue?vue&type=style&index=0&id=8571b5d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8571b5d4",
  null
  
)

export default component.exports